import { render, staticRenderFns } from "./Site-drawer.vue?vue&type=template&id=be5bedce&"
import script from "./Site-drawer.vue?vue&type=script&lang=js&"
export * from "./Site-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports